<template>
<div class="new-inventory-order">
    <div class="main-content-full">
        <div class="controller-container">
            <div class="controller-content">
                <el-button @click="newOrder">新 建</el-button>
            </div>
        </div>
        <div class="table-container">
            <el-table :data="tableData" style="width: 100%" :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle">
                <el-table-column align="center" prop="storage_id" label="入库单号" min-width="15%">
                </el-table-column>
                <el-table-column align="center" prop="create_time" label="入库时间" min-width="20%">
                </el-table-column>
                <el-table-column align="center" prop="good_name" label="商品名称" min-width="25%">
                </el-table-column>
                <el-table-column align="center" prop="price" label="入库价格" min-width="10%">
                </el-table-column>
                <el-table-column align="center" prop="numbers" label="数量" min-width="10%">
                </el-table-column>
                <el-table-column align="center" prop="unit" label="规格" min-width="10%">
                </el-table-column>
                <el-table-column align="center" prop="warehouse_name" label="入库仓库" min-width="15%">
                </el-table-column>
                <el-table-column align="center" prop="create_by" label="制单人" min-width="15%">
                </el-table-column>
            </el-table>
        </div>
    </div>
    <el-dialog title="录入商品入库信息" :visible.sync="dialogFormVisible">
        <el-form :model="newOrderForm">
            <el-form-item label="入库商品" :label-width="formLabelWidth">
                <el-cascader
                    expand-trigger="hover"
                    :options="goodsOptions"
                    v-model="goodsSelectedOptions"
                    placeholder="请输入入库商品"
                    @change="selectGoods">
                </el-cascader>
            </el-form-item>
            <el-form-item label="仓库" :label-width="formLabelWidth">
                <el-select v-model="warehouseIndex" placeholder="请输入入库仓库">
                    <el-option v-for="(item, index) in warehouseArr" :key="index" :label="item.warehouse_name" :value="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="数量" :label-width="formLabelWidth">
                <el-input v-model="newOrderForm.numbers" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="入库价格" :label-width="formLabelWidth">
                <el-input v-model="newOrderForm.price" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="newOrderQuit">取 消</el-button>
            <el-button type="primary" @click="newOrderOk">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import Tool from '../../assets/js/Tool.js';
import {
    mapGetters,
    mapMutations
} from 'vuex';
export default {
    data() {
        return {
            tableData: [],
            newOrderForm: {
                good_id: '',
                numbers: '',
                price: '',
                warehouse_id: '',
            },
            goodsOptions: [],
            goodsSelectedOptions: [],
            warehouseArr: [],
            warehouseIndex: '',
            dialogFormVisible: false,
            formLabelWidth: '120px'
        }
    },
    computed: {
        ...mapGetters(['user', 'userTypeNum'])
    },
    created() {
        this.init();
    },
    methods: {
        changeTableHeaderStyle({
            row,
            rowIndex
        }) {
            return 'color:black; font-weight: bold;';
        },
        changeTableStyle({
            row,
            column,
            rowIndex,
            columnIndex
        }) {
            if (columnIndex == 5) {
                if (row.status_num == -1) {
                    return 'color: #FF3333;'
                } else if (row.status_num == 0) {
                    return 'color: #29bd7f;'
                } else if (row.status_num == 1) {
                    return 'color: #e6a23c;'
                }
            }
            return 'color: #000;'
        },
        init() {
            this.axios.get('storageorder_list', {
                    params: {
                        user_id: this.user.id
                    }
                })
                .then(res => {
                    this.tableData = res.data.data;
                })
        },
        getGoodsMenu() {
            this.axios.get('good_connection')
            .then(res => {
                this.goodsOptions = res.data.data;
            })
        },
        getWarehouseMenu() {
            this.axios.get('getwarehouse', {
                params: {
                    user_id: this.user.id,
                    type: 1
                }
            })
            .then(res => {
                this.warehouseArr = res.data.data;
            })
        },
        // 新建入库单
        newOrder() {
            this.getGoodsMenu();
            this.getWarehouseMenu();
            this.dialogFormVisible = true;
        },
        newOrderOk() {
            this.newOrderForm.numbers = parseFloat(this.newOrderForm.numbers);
            this.newOrderForm.price = parseFloat(this.newOrderForm.price);
            this.newOrderForm.good_id = this.goodsSelectedOptions[1];
            this.newOrderForm.warehouse_id = this.warehouseArr[this.warehouseIndex].warehouse_id;
            
            let sendObj = Object.assign({
                storage_id: Tool.getUniqueRandom(),
                user_id: this.user.id,
            }, this.newOrderForm);
            
            this.axios.post('in_storageorder', JSON.stringify(sendObj))
            .then(res => {
                this.dialogFormVisible = false;
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
            })
        },
        newOrderQuit() {
            this.newOrderForm.numbers = '';
            this.newOrderForm.price = '';
            this.dialogFormVisible = false;
        },
        // 选择商品
        selectGoods(value) {
            console.log(value);
        }
    }
}
</script>

<style scoped>
@import url(../../assets/css/base.css);

.new-inventory-order {
    background-color: #F9F9F9;
}

.action-select-first,
.action-select-inventory {
    margin-left: 24px;
    width: 161px;
}

.action-select-first {
    margin-left: 0px;
}

.controller-container {
    background-color: #d2f5e8;
}

.controller-content {
    margin: 0 auto;
    width: 1290px;
    padding-top: 13px;
}
</style>



// WEBPACK FOOTER //
// src/pages/inventoryManage/NewInventoryOrder.vue